import React from 'react';
import { WarningBanner } from '@app/react-common/components/banners/WarningBanner';
import { AbTestWidgetType } from '../../../../models/AbTestCreationType';

interface ThemeTestDisclaimerProps {
  widgetType?: AbTestWidgetType;
}

const ASSIGNMENT_TARGET_LABELS: Partial<Record<AbTestWidgetType, string>> = {
  [AbTestWidgetType.PRODUCT_PAGE]: 'product promise',
  [AbTestWidgetType.SMART_CART]: 'smart cart',
};

export function ThemeTestDisclaimer({ widgetType }: ThemeTestDisclaimerProps) {
  const assignmentTarget = (widgetType && ASSIGNMENT_TARGET_LABELS[widgetType]) || 'theme';
  const showThemeSyncNote = widgetType === AbTestWidgetType.CROSS_SITE;

  const disclaimerContent = (
    <ul className="theme-test-disclaimer__list">
      <li className="theme-test-disclaimer__item">
        Have a running Shipping Rates A/B test? Shipping rates groups assigned to a {assignmentTarget} will take
        priority.
      </li>
      {showThemeSyncNote && (
        <li className="theme-test-disclaimer__item">
          Theme changes may take up to 10 minutes to sync from Shopify to PDQ.
        </li>
      )}
    </ul>
  );

  return (
    <div className="theme-test-disclaimer">
      <WarningBanner variant="attention" hideCloseButton title="Attention" content={disclaimerContent} />
    </div>
  );
}
